module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec04_pc_5d8cec3d52e4b2c1de3689d32436a9aa.jpg";